import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'

export default reducers => {
  const persitedReducer = persistReducer(
    {
      key: 'adxv2',
      storage,
      whitelist: ['auth', 'usuario'],
    },
    reducers
  )

  return persitedReducer
}
